// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_db-3";
export var flatBottomCorners = "_db-5";
export var productImage = "_db-0";
export var quantityContainer = "_db-2";
export var quantityHeader = "_db-6";
export var tooltip = "_db-1";
export var wrapAndEllipsesOverflow = "_db-4";